var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"csr-select"},[_c('FormItem',_vm._b({},'FormItem',_setup.state.conf,false),[_c('md-select',_vm._b({attrs:{"value":_setup.state.conf.multiple ? _setup.state.value?.split(',') : _setup.state.value,"popper-append-to-body":false},on:{"change":_setup.handleChange,"blur":_setup.handleBlur}},'md-select',{
          ..._vm.$attrs,
          ..._setup.state.conf,
        },false),_vm._l((_setup.state.conf.dataSource),function(item){return _c('md-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }